import { mixed, object, string } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

import { PHONE_CALL_KINDS } from './constants'

export const getLocationConfigurationValidationSchema = ({ requireKind = false } = {}) => object({
  kind: requireKind ? mixed().required() : mixed(),
  phoneNumber: mixed()
    .when('kind', {
      is: PHONE_CALL_KINDS.inbound,
      then: string()
        .required(I18n.t('errors.event_types.phone_number'))
        .phoneNumber(I18n.t('errors.event_types.phone_number'))
    }),
  location: mixed()
    .when('kind', {
      is: 'physical',
      then: string()
        .nullable()
        .trim()
        .required(I18n.t('publisher.event_types.location.physical_location_required'))
    })
    .when('kind', {
      is: 'custom',
      then: string()
        .nullable()
        .trim()
        .required(I18n.t('publisher.event_types.location.custom_location_required'))
        .matches(/^[^<>]*$/, I18n.t('publisher.event_types.location.custom_location_invalid_character'))
    }),
  additionalInfo: mixed()
    .when('kind', {
      is: (kind) => kind === 'physical' || kind === 'inbound_call',
      then: string().trim()
    }),
  hideLocation: mixed()
    .when('kind', {
      is: 'custom',
      then: string().required().oneOf(['hidden', 'visible'])
    }),
})
